/// <amd-module name="Build/DesignerExtensions/ExtendsCheckPanel/Components/ExtendsCheckConfig" />
import * as PipelineChecksContracts from "Checks/Client/Contracts/PipelinesChecks";

export const extendsCheckTypeId: string = "4020E66E-B0F3-47E1-BC88-48F3CC59B5F3";
export const extendsCheckTypeName: string = "ExtendsCheck";

export interface IExtendsCheckConfiguration extends PipelineChecksContracts.CheckConfiguration {
    settings: IExtendsCheckConfig;
}

export interface IExtendsCheckConfig {
    extendsChecks: IExtendsCheck[];
}

export interface IExtendsCheck {
    repositoryType: string;
    repositoryName: string;
    repositoryRef: string;
    templatePath: string;
}
